
import * as React from 'react';
import styled from 'styled-components';
import { AgGridReact } from 'ag-grid-react';
import { type ColDef, themeAlpine } from 'ag-grid-community';
import '@process-advisor/process-miner/shared/gridStyles.css'
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
const Wrapper = styled.div`
    width: 100%;
    margin-bottom: 5px;
`;

type SingleRow = {
    id: number;
    [key: string]: any
}

type Props = {
    rows: SingleRow[];
    columns: ColDef[];
    height: string;
    setApplyEnabled: (value: boolean) => void;       
    setDeleteDisabled: (value: boolean) => void;
}

export const DataGrid: React.FC<Props> = ({
    rows,
    columns,
    height,
    setApplyEnabled,    
    setDeleteDisabled,
}) => {

    const onSelectionChanged = (params) => {
        const selectedNodes = params.api.getSelectedNodes();
        const selectedData = selectedNodes.map(node => node.data);
        if (selectedData.length > 0) {
            apiProvider.setFilterDeleteRow({row: selectedData[0].id});
            setDeleteDisabled(false);
        }
    };
   

    const onModelUpdated = (params) => {
        if (params.api.getDisplayedRowCount() > 0) {setApplyEnabled(false)} else {setApplyEnabled(true)};
    };

    return (
        <Wrapper>
            <div
                
                style={{
                    width: '100%',
                    fontSize: '12px',
                    fontFamily: 'system-ui'
,
                }}>
                <AgGridReact theme={themeAlpine} 
                    onModelUpdated={onModelUpdated}
                    rowSelection="single"
                    onSelectionChanged={onSelectionChanged}                    
                    columnDefs={columns}
                    domLayout='autoHeight'
                    defaultColDef={{
                        sortable: true,
                        filter: true,
                        resizable: true,
                        wrapText: true,
                        autoHeight: true,
                    }}
                    rowData={rows} />
            </div>
        </Wrapper>
    );
};
